import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Intercom from 'react-intercom';
import { withRouter, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { loginViaToken } from '../actions/auth';
import { GOOGLE_API_KEY, appPath } from '../constants';
import { getSavedAuthToken } from '../api/httpClient';
import { analyticsKeys } from '../constants/analytics';
import Loader from './common/ui/Loader';
import ConversationContainer from './app/messages/ConversationContainer';
import AppComponent from './AppComponent';
import { onlyForAdmin } from './router/AppRouts';
import UIModals from './common/ui/UIModals';
import UsersService from '../services/UsersService';

import 'react-datepicker/dist/react-datepicker.css';

class App extends Component {
  static propTypes = {
    loginViaToken: PropTypes.func.isRequired
  };

  state = { apiLoaded: false };

  componentWillMount () {
    const token = getSavedAuthToken();
    if (token) {
      this.props.loginViaToken(token).then(data => {
        if (!data) {
          this.props.history.push(`/`);
        }
      });
    }
  }

  componentDidMount () {
    window.initGoogleComponents = function () {};
    const googleScript = document.createElement('script');
    googleScript.type = 'text/javascript';
    googleScript.async = true;
    googleScript.defer = true;
    googleScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_API_KEY}&libraries=places&callback=initGoogleComponents&language=en`;
    document.body.insertAdjacentElement(`afterbegin`, googleScript);

    this.setState({ apiLoaded: true });
  }

  render () {
    if (!this.state.apiLoaded || UsersService.isLoading) {
      return <Loader />;
    }
    return (
      <React.Fragment>
        <Intercom appID={analyticsKeys.INTERCOM_KEY} />
        <Switch>
          <Route exact path={`/${appPath}/conversation/:id`} component={onlyForAdmin(ConversationContainer)} />
          <Route path='/' component={AppComponent} />
        </Switch>
        <UIModals />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user
});

export default withRouter(connect(mapStateToProps, { loginViaToken })(App));



// WEBPACK FOOTER //
// ./src/components/App.js